import { AppErrorItem } from '@domain-utils/app-error-item';

export interface LoadRequest {
  policyNumber: string;
  operationType: string;
}

export interface LoadResponse {
  loadId: string;
}

export interface UploadFileResponse {
  loadId: string;
  status: LoadStatus;
  statusDescription: string;
  totalRows: number;
  rowsWithErrors: number;
  errorCount: number;
  annotatedFileName?: string | null;
  annotatedFileBase64?: string | null;
  hasErrors: boolean;
}

export interface UploadIssueDetail {
  codes: AppErrorItem[];
  fileBase64: string | null;
  fileName: string | null;
}

export interface ContentReportLoadResponse {
  content: ReportLoad[];
  currentPage: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface ReportLoadPage {
  items: ReportLoad[];
  totalRecords: number;
}

export interface ReportLoad {
  loadId: string;
  policyNumber: string;
  status: LoadStatus;
  statusDescription: string;
  operation: string;
  operationCode: string;
  createdAt: string | Date;
  totalRecords: number;
  processedRecords: number;
  errorCount: number;
  message?: string;
}

export interface UploadResult {
  loadId: string;
  uploadResponse: UploadFileResponse;
}

export enum LoadStatus {
  CREATED = 'CREATED',
  VALIDATING = 'VALIDATING',
  VALIDATED = 'VALIDATED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  PROCESSING = 'PROCESSING',
  MATERIALIZING = 'MATERIALIZING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}
